import React, { createContext, useState, useContext } from 'react'

import { getFormByIdForm } from '../services/Elegibilidad/get'
const ElegibilidadContext = createContext()

export const ElegibilidadProvider = (props) => {
  const [EligibilityForm, setEligibilityForm] = useState({})
  const [PreEligibilityForm2, setPreEligibilityForm2] = useState({})
  const [idElegibilityForm, setIdElegibilityForm] = useState('')
  const [editFormElegibility, setEditFormElegibility] = useState([])
  const [idEditForm, setIdEditForm] = useState([])
  const [loadingData, setLoadingData] = useState(true)

  const getEditFormElegibility = async (idFormxxx) => {
    setEditFormElegibility({ loading: true, list: '' })
    const response = await getFormByIdForm(idFormxxx)
    if (response.Code === 200) {
      const values = response.Data
      // mapAnswerForEdit(values)
      setEditFormElegibility(values)
      setLoadingData(false)
    } else {
      setEditFormElegibility()
      setLoadingData(false)
    }
  }

  return (
    <ElegibilidadContext.Provider
      value={{
        setEligibilityForm,
        EligibilityForm,
        idElegibilityForm,
        setIdElegibilityForm,
        idEditForm,
        setIdEditForm,
        editFormElegibility,
        setEditFormElegibility,
        getEditFormElegibility,
        PreEligibilityForm2,
        setPreEligibilityForm2,
        loadingData,
        setLoadingData,
      }}
    >
      {props.children}
    </ElegibilidadContext.Provider>
  )
}

export const useFormElegibilidad = () => {
  const context = useContext(ElegibilidadContext)
  if (context === undefined) {
    throw new Error('useForm can only be used inside FormProvider')
  }
  return context
}
